<template>
  <VView class="home">
    <VBlock class="home__crown" max-width="106px">
      <img src="@/assets/crown.png" />
    </VBlock>

    <hr />
    <VText class="home__cta" center big>poznaj pufka<br />i jego przyjaciół</VText>
    <hr />
    <!-- <VText center big>zmierz się w naszej grze<br />i wygraj jedną z super nagród!</VText> -->
    <VText center big>zmierz się w naszej grze!</VText>

    <!-- <VBlock class="home__prizes">
      <img src="@/assets/home-prizes.png" />
    </VBlock> -->

    <VBlock max-width="500px">
      <transition name="bounceUp" appear>
        <VButton to="/menu">{{ $t('home.button') }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style lang="scss" scoped>
.home {
  &__prizes {
    max-width: none !important;
    margin: $gridGutter calc($gridGutter * -3) 0 !important;

    @media screen and (max-width: 900px) {
      margin: $gridGutter calc($gridGutter * -2) 0 !important;
    }
  }

  &__crown {
    margin-bottom: -30px !important;
  }

  &__cta {
    font-size: font(30px, 80px) !important;
  }

  hr {
    border: none;
    height: 5px;
    width: 100%;
    background-color: #1a1109;
    max-width: 545px;
  }
}
</style>
